import { Modal, Form, Input, Button, DatePicker, App, Select, InputNumber, Space, Alert } from 'antd';
import React, { useEffect, useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, models } from "@vote4dance/judging-sdk";
import dayjs from 'dayjs';
var Api = apis.Api;
var RegistrationPeriodSource = models.registration.RegistrationPeriodSource;
import { CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
import { Link } from 'react-router-dom';
const dateTimeFormat = 'YYYY-MM-DD HH:mm';
const { RangePicker } = DatePicker;
export const RegistrationPeriodEdit = (props) => {
    const { event, competition, item, disabled } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const registrationPeriodSource = RegistrationPeriodSource(competition === null || competition === void 0 ? void 0 : competition.competition_id);
    let billingCustomer;
    if (event === null || event === void 0 ? void 0 : event.competition_billing_reference) {
        try {
            var json = JSON.parse(event.competition_billing_reference);
            if (typeof json === 'object' && json.customer_id) {
                billingCustomer = json;
            }
        }
        catch (e) {
            // Old customers, skip
        }
    }
    const openModal = () => {
        setVisible(true);
    };
    const handleCancel = () => {
        form.resetFields();
        setVisible(false);
    };
    useEffect(() => {
        if (form) {
            form.resetFields();
        }
    }, []);
    useEffect(() => {
        if (form && item) {
            form.setFieldsValue(getDefaultValue());
            setIsValid(item.registration_payment_type === 'online' ? billingCustomer : true);
        }
    }, [item]);
    const getDefaultValue = () => {
        var _a;
        return ({
            registration_price_per: 'person',
            registration_currency: 'sek',
            registration_payment_type: (_a = item === null || item === void 0 ? void 0 : item.registration_payment_type) !== null && _a !== void 0 ? _a : 'manual',
            registration_accept: 'manual',
            ...item,
            registration_prices: item && item.registration_prices ? JSON.parse(item.registration_prices) : [],
            registration_period: item && item.registration_start_at && item.registration_end_at && [dayjs.utc(item.registration_start_at).tz(competition === null || competition === void 0 ? void 0 : competition.competition_timezone), dayjs.utc(item.registration_end_at).tz(competition === null || competition === void 0 ? void 0 : competition.competition_timezone)]
        });
    };
    const onFinish = async (fieldsValue) => {
        const updateItem = {
            ...item,
            ...fieldsValue,
            registration_prices: fieldsValue['registration_prices'] && JSON.stringify(fieldsValue['registration_prices']),
            registration_start_at: fieldsValue['registration_period'] && fieldsValue['registration_period'][0].utc().format(dateTimeFormat),
            registration_end_at: fieldsValue['registration_period'] && fieldsValue['registration_period'][1].utc().format(dateTimeFormat)
        };
        setIsLoading(true);
        try {
            // Update registration period
            if (item) {
                await Api.update(`${registrationPeriodSource.url}/${item.registration_period_id}`, updateItem);
            }
            else {
                await Api.create(registrationPeriodSource.url, updateItem);
            }
            handleCancel();
        }
        catch (err) {
            notification.error({
                message: err.response && err.response.message ? _T(err.response.message) : err.message
            });
        }
        setIsLoading(false);
    };
    const onDeleteRound = async (item, done) => {
        await Api.destroy(`${registrationPeriodSource.url}/${item.registration_period_id}`)
            .catch((err) => {
            notification.error({
                message: err.response.message ? _T(err.response.message) : err.message
            });
        });
        done();
    };
    const onValuesChange = (changedValues, allValues) => {
        setIsValid(allValues['registration_payment_type'] === 'online' ? billingCustomer : true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { disabled: disabled, icon: item ? React.createElement(EditOutlined, null) : React.createElement(PlusOutlined, null), onClick: openModal }, _T(item ? 'common.edit' : 'common.add', { name: _T('registrationperiod.title').toLowerCase() })),
        React.createElement(Modal, { title: _T(item ? 'common.edit' : 'common.add', { name: _T('registrationperiod.title').toLowerCase() }), open: visible, width: 700, onCancel: handleCancel, footer: [
                item &&
                    React.createElement(ButtonConfirm, { title: _T('common.delete.title'), description: _T('common.delete.content', { name: _T('registrationperiod.title').toLowerCase() }), onConfirm: (done) => onDeleteRound(item, done), key: "delete", buttonProps: {
                            danger: true,
                            icon: React.createElement(DeleteOutlined, null)
                        } }),
                React.createElement(Button, { key: "cancel", onClick: handleCancel }, _T('common.cancel.title')),
                React.createElement(Button, { key: "submit", type: "primary", form: `registration_period_${item === null || item === void 0 ? void 0 : item.registration_period_id}`, htmlType: 'submit', disabled: isLoading || !isValid, loading: isLoading }, _T('common.save')),
            ] },
            React.createElement(Form, { name: `registration_period_${item === null || item === void 0 ? void 0 : item.registration_period_id}`, form: form, layout: "vertical", disabled: isLoading, onFinish: onFinish, initialValues: getDefaultValue(), onValuesChange: onValuesChange },
                React.createElement(Form.Item, { name: "registration_period_name", rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Input, { allowClear: true, placeholder: _T('common.add', { name: _T('registrationperiod.details.registration_period_name').toLowerCase() }) })),
                React.createElement(Form.Item, { name: "registration_period", rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(RangePicker, { showTime: true, format: dateTimeFormat })),
                React.createElement(Form.Item, { name: "registration_payment_type", label: _T('registrationperiod.details.registration_payment_type.label'), rules: [{ required: true, message: _T('common.required') }], help: React.createElement(React.Fragment, null,
                        _T('registrationperiod.cost'),
                        " + ",
                        React.createElement(Link, { to: "https://stripe.com/pricing", target: "_blank" }, "Stripe")) },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: "free" }, _T('registrationperiod.details.registration_payment_type.free')),
                        React.createElement(Select.Option, { value: "manual" }, _T('registrationperiod.details.registration_payment_type.manual')),
                        React.createElement(Select.Option, { value: "online" }, _T('registrationperiod.details.registration_payment_type.online')))),
                React.createElement(Form.Item, { name: "registration_accept", label: _T('registrationperiod.details.registration_accept.label'), rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: "manual" }, _T('registrationperiod.details.registration_accept.manual')),
                        React.createElement(Select.Option, { value: "auto", disabled: true }, _T('registrationperiod.details.registration_accept.auto')),
                        React.createElement(Select.Option, { value: "direct" }, _T('registrationperiod.details.registration_accept.direct')))),
                React.createElement(Form.Item, { dependencies: ['registration_payment_type'], noStyle: true }, ({ getFieldValue }) => React.createElement(Form.Item, { name: "registration_currency", label: _T('registration.currency.placeholder'), hidden: getFieldValue('registration_payment_type') == "free" },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: "sek", key: 0 }, _T('registration.currency.sek')),
                        React.createElement(Select.Option, { value: "eur", key: 1 }, _T('registration.currency.eur')),
                        React.createElement(Select.Option, { value: "usd", key: 2 }, _T('registration.currency.usd')),
                        React.createElement(Select.Option, { value: "nok", key: 3 }, _T('registration.currency.nok'))))),
                React.createElement(Form.Item, { dependencies: ['registration_payment_type', 'registration_currency'], noStyle: true }, ({ getFieldValue }) => React.createElement(Form.Item, { hidden: getFieldValue('registration_payment_type') == "free", noStyle: true },
                    React.createElement(Form.List, { name: "registration_prices" }, (fields, { add, remove }, { errors }) => (React.createElement(React.Fragment, null,
                        fields.map(({ key, name, ...restField }, index) => (React.createElement(Space, { key: key, style: { display: 'flex', marginBottom: 8 }, align: "baseline" },
                            React.createElement(Form.Item, { ...restField, name: [name, 'price'], rules: [{ required: true, message: _T('common.required') }] },
                                React.createElement(InputNumber, { addonBefore: _T('registrationperiod.details.registration_prices', { number: index + 1 }), addonAfter: _T('registration.currency.' + getFieldValue('registration_currency')) })),
                            React.createElement(CloseOutlined, { onClick: () => remove(name) })))),
                        React.createElement(Form.Item, null,
                            React.createElement(Button, { type: "dashed", onClick: () => add(), icon: React.createElement(PlusOutlined, null) }, _T('common.add', { name: _T('registration.price').toLowerCase() })),
                            React.createElement(Form.ErrorList, { errors: errors }))))))),
                React.createElement(Form.Item, { name: "registration_price_per", label: _T('registrationperiod.details.registration_price_per.label'), rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: "person" }, _T('registrationperiod.details.registration_price_per.person')),
                        React.createElement(Select.Option, { value: "entry" }, _T('registrationperiod.details.registration_price_per.entry')))),
                React.createElement(Form.Item, { label: _T('common.description'), name: "registration_info" },
                    React.createElement(Input.TextArea, null))),
            !isValid &&
                React.createElement(Alert, { title: _T('customer.connect.action'), description: _T('customer.connect.customer'), type: "warning", showIcon: true, closable: true }))));
};
